<script>
/**
 * Descripción: BaseCard reutilizable
 *
 * @displayName BaseCard
 */

export default {
  name: 'BaseCard'
};
</script>

<template>
  <v-card flat tile v-bind="$attrs" v-on="$listeners">
    <slot />
  </v-card>
</template>
